
<div [hidden]="(hasMissingValue$ | async) === true">
	<ng-template #container></ng-template>
</div>
<div class="markdown-html text-center" [hidden]="(hasMissingValue$ | async) !== true">
		<div>{{ 'workflow.test.completed' | translate }}</div>
		<div>{{ 'workflow.missing_value_epilog' | translate }}</div>
		<div class="centered div-table">
			<workflow-overview-item *ngFor="let config of overviewConfigs"
					[finishedAndLocked]="finishedAndLocked"
					[config]="config"
					[alignTextLeft]="true"
					class="div-table-line"
			></workflow-overview-item>
		</div>
</div>
